export type PopularChoiceConfig = {
  enabled?: boolean | null
  viewsFrom?: number | null
  viewsTo?: number | null
}

export type PopularChoiceBannerCopy = {
  popularChoiceBody: string
  popularChoiceTitle: string
}

export function todayUtcDateString(): string {
  return new Date().toISOString().slice(0, 10)
}

function hashSeed(seed: string): number {
  let hash = 5381

  for (let index = 0; index < seed.length; index += 1) {
    hash = (hash * 33 + seed.charCodeAt(index)) >>> 0
  }

  return hash
}

function normalizeBound(value: number | null | undefined): number {
  if (value == null || Number.isNaN(value)) {
    return 0
  }

  return Math.max(0, value)
}

/**
 * Deterministic view count for the Popular choice banner.
 * Same seed + range always yields the same number (SSR/client safe).
 */
export function getSeededPopularChoiceViews(seed: string, from: number, to: number): number {
  const normalizedFrom = normalizeBound(from)
  const normalizedTo = normalizeBound(to)

  if (normalizedTo < normalizedFrom) {
    return normalizedFrom
  }

  const range = normalizedTo - normalizedFrom

  if (range === 0) {
    return normalizedFrom
  }

  return normalizedFrom + (hashSeed(seed) % (range + 1))
}

export function buildPopularChoiceBannerProps(
  apartmentId: string,
  config: PopularChoiceConfig | null | undefined,
  copy: PopularChoiceBannerCopy,
  dateSeed = todayUtcDateString(),
): { body: string; title: string } | null {
  if (!config?.enabled) {
    return null
  }

  const viewsFrom = normalizeBound(config.viewsFrom)
  const viewsTo = normalizeBound(config.viewsTo)
  const count = getSeededPopularChoiceViews(`${apartmentId}:${dateSeed}`, viewsFrom, viewsTo)

  return {
    title: copy.popularChoiceTitle,
    body: copy.popularChoiceBody.replace('{count}', String(count)),
  }
}
